import $ from 'jquery';

export default function() {
	var pdf = ':not([href$=".pdf"])',
		hp = ':not([href^="http://healthpartners"])',
		hpWww = ':not([href^="http://www.healthpartners"])',
		hpHttps = ':not([href^="https://healthpartners"])',
		hpHttpsWww = ':not([href^="https://www.healthpartners"])',
		vw = ':not([href^="http://virtuwell"])',
		vwWww = ':not([href^="http://www.virtuwell"])',
		vwHttps = ':not([href^="https://virtuwell"])',
		vwHttpsWww = ':not([href^="https://www.virtuwell"])',
		r = ':not([href^="http://regionshospital"])',
		rWww = ':not([href^="http://www.regionshospital"])',
		rHttps = ':not([href^="https://regionshospital"])',
		rHttpsWww = ':not([href^="https://www.regionshospital"])',
		pn = ':not([href^="http://parknicollet"])',
		pnWww = ':not([href^="http://www.parknicollet"])',
		pnHttps = ':not([href^="https://parknicollet"])',
		pnHttpsWww = ':not([href^="https://www.parknicollet"])',
		hw = ':not([href^="http://healthwise"])',
		hwWww = ':not([href^="http://www.healthwise"])',
		hwHttps = ':not([href^="https://healthwise"])',
		hwHttpsWww = ':not([href^="https://www.healthwise"])',
		ix = ':not([href^="http://ixconversations.healthwise"])',
		ixWww = ':not([href^="http://www.ixconversations.healthwise"])',
		ixHttps = ':not([href^="https://ixconversations.healthwise"])',
		ixHttpsWww = ':not([href^="https://www.ixconversations.healthwise"])',
		shp = ':not([href^="http://surveys.healthpartners"])',
		shpWww = ':not([href^="http://www.surveys.healthpartners"])',
		shpHttps = ':not([href^="https://surveys.healthpartners"])',
		shpHttpsWww = ':not([href^="https://www.surveys.healthpartners"])',
		amc = ':not([href^="http://amerymedicalcenter"])',
		amcWww = ':not([href^="http://www.amerymedicalcenter"])',
		amcHttps = ':not([href^="https://amerymedicalcenter"])',
		amcHttpsWww = ':not([href^="https://www.amerymedicalcenter"])',
		hh = ':not([href^="http://hudsonhospital"])',
		hhWww = ':not([href^="http://www.hudsonhospital"])',
		hhHttps = ':not([href^="https://hudsonhospital"])',
		hhHttpsWww = ':not([href^="https://www.hudsonhospital"])',
		lv = ':not([href^="http://lakeviewhealth"])',
		lvWww = ':not([href^="http://www.lakeviewhealth"])',
		lvHttps = ':not([href^="https://lakeviewhealth"])',
		lvHttpsWww = ':not([href^="https://www.lakeviewhealth"])',
		pnbc = ':not([href^="http://pnbconline"])',
		pnbcWww = ':not([href^="http://www.pnbconline"])',
		pnbcHttps = ':not([href^="https://pnbconline"])',
		pnbcHttpsWww = ':not([href^="https://www.pnbconline"])',
		tria = ':not([href^="http://tria"])',
		triaWww = ':not([href^="http://www.tria"])',
		triaHttps = ':not([href^="https://tria"])',
		triaHttpsWww = ':not([href^="https://www.tria"])',
		wfh = ':not([href^="http://westfieldshospital"])',
		wfhWww = ':not([href^="http://www.westfieldshospital"])',
		wfhHttps = ':not([href^="https://westfieldshospital"])',
		wfhHttpsWww = ':not([href^="https://www.westfieldshospital"])',
		cp = ':not([href^="http://cosmetic-plasticsurgeons"])',
		cpWww = ':not([href^="http://www.cosmetic-plasticsurgeons"])',
		cpHttps = ':not([href^="https://cosmetic-plasticsurgeons"])',
		cpHttpsWww = ':not([href^="https://www.cosmetic-plasticsurgeons"])',
		hwr = ':not([href^="http://hwrxic.healthwise.net/?client=healthpartners"])',
		hwrWww = ':not([href^="http://www.hwrxic.healthwise.net/?client=healthpartners"])',
		hwrHttps = ':not([href^="https://hwrxic.healthwise.net/?client=healthpartners"])',
		hwrHttpsWww = ':not([href^="https://www.hwrxic.healthwise.net/?client=healthpartners"])',
		dfp = ':not([href^="http://dresnerfacialplasticsurgery"])',
		dfpWww = ':not([href^="http://www.dresnerfacialplasticsurgery"])',
		dfpHttps = ':not([href^="https://dresnerfacialplasticsurgery"])',
		dfpHttpsWww = ':not([href^="https://www.dresnerfacialplasticsurgery"])',
		mvhp = ':not([href^="http://myvoicehealthpartners.com/Portal/default"])',
		mvhpWww = ':not([href^="http://www.myvoicehealthpartners.com/Portal/default"])',
		mvhpHttps = ':not([href^="https://myvoicehealthpartners.com/Portal/default"])',
		mvhpHttpsWww = ':not([href^="https://www.myvoicehealthpartners.com/Portal/default"])',
		ohpe = ':not([href^="http://healthpartnersohpe"])',
		ohpeWww = ':not([href^="http://www.healthpartnersohpe"])',
		ohpeHttps = ':not([href^="https://healthpartnersohpe"])',
		ohpeHttpsWww = ':not([href^="https://www.healthpartnersohpe"])',
		hphm = ':not([href^="http://hphealthmatters"])',
		hphmWww = ':not([href^="http://www.hphealthmatters"])',
		hphmHttps = ':not([href^="https://hphealthmatters"])',
		hphmHttpsWww = ':not([href^="https://www.hphealthmatters"])',
		tw = ':not([href^="https://www.twitter"])',
		fb = ':not([href^="https://www.facebook"])',
		yt = ':not([href^="https://www.youtube"])',
		ig = ':not([href^="https://instagram.com/healthpartners"])',
		httpQuery =
			'a[href^="http://"]' +
			pdf +
			hp +
			hpWww +
			vw +
			vwWww +
			r +
			rWww +
			pn +
			pnWww +
			hw +
			hwWww +
			ix +
			ixWww +
			shp +
			shpWww +
			amc +
			amcWww +
			hh +
			hhWww +
			lv +
			lvWww +
			pnbc +
			pnbcWww +
			tria +
			triaWww +
			wfh +
			wfhWww +
			cp +
			cpWww +
			hwr +
			hwrWww +
			dfp +
			dfpWww +
			mvhp +
			mvhpWww +
			ohpe +
			ohpeWww +
			hphm +
			hphmWww,
		httpsQuery =
			'a[href^="https://"]' +
			pdf +
			hpHttps +
			hpHttpsWww +
			vwHttps +
			vwHttpsWww +
			rHttps +
			rHttpsWww +
			pnHttps +
			pnHttpsWww +
			hwHttps +
			hwHttpsWww +
			ixHttps +
			ixHttpsWww +
			shpHttps +
			shpHttpsWww +
			amcHttps +
			amcHttpsWww +
			hhHttps +
			hhHttpsWww +
			lvHttps +
			lvHttpsWww +
			pnbcHttps +
			pnbcHttpsWww +
			triaHttps +
			triaHttpsWww +
			wfhHttps +
			wfhHttpsWww +
			cpHttps +
			cpHttpsWww +
			hwrHttps +
			hwrHttpsWww +
			dfpHttps +
			dfpHttpsWww +
			mvhpHttps +
			mvhpHttpsWww +
			ohpeHttps +
			ohpeHttpsWww +
			hphmHttps +
			hphmHttpsWww +
			tw +
			fb +
			yt +
			ig;
	$(httpQuery + ', ' + httpsQuery).addClass('external-link');
}



// WEBPACK FOOTER //
// ./src/webpack/components/external-links.js